<template>
  <div class="member-progress-viewer h-full">
    <vx-card class="h-full" :title="$t('view_member.block.progress_viewer.title')" :loading="loading">
      <template slot="actions">
        <vs-row v-if="sessionTypes">
          <vs-col>
            <vs-select :autocomplete="false" v-model="sessionTypeSelected" @input="onSelectSessionType">
              <vs-select-item v-for="(type, typeIdx) in sessionTypes" :key="type.value" :value="typeIdx" :text="type.label"></vs-select-item>
            </vs-select>
          </vs-col>
        </vs-row>
      </template>
      <template v-if="products && products.length">
        <vs-row vs-justify="center">
          <vs-col vs-w="12" class="pb-2" v-if="sessionTypeSelected != null">
            <vs-row>
              <vs-col vs-w="4">
                <h5 class="starling-h5 pl-4">{{ sessionTypes[sessionTypeSelected].moduleLabel }}</h5>
              </vs-col>
              <vs-col vs-w="4">
                <h5 class="starling-h5 pl-4">{{ sessionTypes[sessionTypeSelected].sessionLabel }}</h5>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-w="4" class="pr-1">
            <div class="content-viewer">
              <vs-list v-if="products">
                <vs-list-item v-for="product in products" :key="product.id" :title="product.title"
                              @click.native="onSelectProduct(product.id)"
                              :class="{ 'selected': productSelected === product.id }">
                  <div class="status-background" :class="`icon-${product.status.toLowerCase()}`">
                    <div class="status-icon" :class="`icon-${product.status.toLowerCase()}`">
                      <vs-icon v-if="product.status === 'COMPLETED'" icon="mdi-check-circle" icon-pack="mdi"
                               color="success"></vs-icon>
                      <vs-icon v-else-if="product.status === 'STARTED'" icon="mdi-circle-half-full" icon-pack="mdi"
                               color="success"></vs-icon>
                      <vs-icon v-else-if="product.status === 'INITIAL'" icon="mdi-circle-outline" icon-pack="mdi"
                               color="success"></vs-icon>
                      <vs-icon v-else-if="product.status === 'HIDDEN'" icon="mdi-eye-off" icon-pack="mdi"
                               color="#4F4F4F"></vs-icon>
                      <vs-icon v-else icon="mdi-lock-outline" icon-pack="mdi" color="white"></vs-icon>
                    </div>
                  </div>
                </vs-list-item>
              </vs-list>
            </div>
          </vs-col>
          <vs-col vs-w="4" class="px-1">
            <div class="content-viewer">
              <vs-list v-if="sessions">
                <vs-list-item v-for="session in sessions" :key="session.id" :title="session.title"
                              @click.native="onSelectSession(session.id)"
                              :class="{ 'selected': sessionSelected === session.id }">
                  <div class="status-background" :class="`icon-${session.status.toLowerCase()}`">
                    <div class="status-icon" :class="`icon-${session.status.toLowerCase()}`">
                      <vs-icon v-if="session.status === 'COMPLETED'" icon="mdi-check-circle" icon-pack="mdi"
                               color="success"></vs-icon>
                      <vs-icon v-else-if="session.status === 'STARTED'" icon="mdi-circle-half-full" icon-pack="mdi"
                               color="success"></vs-icon>
                      <vs-icon v-else-if="session.status === 'INITIAL'" icon="mdi-circle-outline" icon-pack="mdi"
                               color="success"></vs-icon>
                      <vs-icon v-else-if="session.status === 'HIDDEN'" icon="mdi-eye-off" icon-pack="mdi"
                               color="#4F4F4F"></vs-icon>
                      <vs-icon v-else icon="mdi-lock-outline" icon-pack="mdi" color="white"></vs-icon>
                    </div>
                  </div>
                </vs-list-item>
              </vs-list>
            </div>
          </vs-col>
          <vs-col vs-w="4" class="pl-1">
            <div class="content-viewer" style="border: 1px solid rgba(0, 0, 0, .08);">
              <member-progress-viewer-content v-if="sessionSelected" :session-resource="sessionResource"
                                              :key="sessionSelected">
                <div class="pt-1 pb-4"
                     v-if="sessionResource.status ==='INITIAL' || sessionResource.status ==='STARTED' || sessionResource.status ==='COMPLETED'">
                  <vs-button
                    v-if="sessionResource.$hasLink('assign-by-email')"
                    type="filled"
                    color="secondary"
                    size="small"
                    @click="assignByEmailStarted=true">
                    Assign by Email
                  </vs-button>
                  <vs-button
                    v-else
                    disabled
                    type="filled"
                    color="secondary"
                    size="small">
                    Assigned
                  </vs-button>
                </div>
                <assign-by-email :key="sessionSelected"
                                 :opened="assignByEmailStarted"
                                 :session-resource="sessionResource"
                                 @sent="onAssignmentSent"
                                 @cancel="assignByEmailStarted=false"/>
              </member-progress-viewer-content>
            </div>
          </vs-col>
        </vs-row>
      </template>

      <template v-else>
        <vs-row>
          <vs-col vs-w="12" class="pb-2">
            <vs-alert>No {{ sessionTypeSelected ? sessionTypes[sessionTypeSelected].label.toLowerCase() : 'modules'}} found.</vs-alert>
          </vs-col>
        </vs-row>
      </template>

    </vx-card>
  </div>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import MemberProgressViewerContent from '@/views/app/view_member/progress/member-progress-viewer-content';
import preview from '@/views/app/send_referral/preview.vue';
import AssignByEmail from '@/views/app/view_member/progress/assign/assign-by-email.vue';

export default {
  name: 'member-progress-viewer',
  components: {
    AssignByEmail,
    preview,
    MemberProgressViewerContent
  },
  props: {
    memberResource: ResourceImpl
  },
  data () {
    return {
      loading: false,
      products: null,
      sessions: null,
      productSelected: null,
      sessionSelected: null,
      sessionResource: null,
      sessionTypeSelected: null,
      assignByEmailStarted: false
    };
  },
  computed: {
    sessionTypes () {
      return this.$t('view_member.block.progress_viewer.session_type.types');
    }
  },
  mounted () {
    this.sessionTypeSelected = 0;
    this.getProductList();
  },
  methods: {
    getProductList () {
      this.productSelected = null;
      this.sessionSelected = null;
      this.sessionResource = null;

      this.loading = true;
      this.memberResource.$request().$get('member-progress-products', { sessionType: this.sessionTypes[this.sessionTypeSelected].value }).then(res => {
        this.products = res.$getEmbedded('products') || [];
        this.sessions = null;
        const recommendedProduct = this.products.find(product => product.recommended);
        if (recommendedProduct) {
          this.onSelectProduct(recommendedProduct.id);
        } else {
          this.loading = false;
        }
      });
    },
    onSelectSessionType () {
      this.getProductList();
    },
    onSelectProduct (productId) {
      this.productSelected = productId;
      this.sessionSelected = null;

      const product = this.products.find(product => product.id === productId);

      this.loading = true;
      product.$request().$get('sessions', { sessionType: this.sessionTypes[this.sessionTypeSelected].value }).then(res => {
        this.sessions = res.$getEmbedded('sessions') || [];
        const recommendedSession = this.sessions.find(session => session.recommended);
        if (recommendedSession) {
          this.onSelectSession(recommendedSession.id);
        }
        this.loading = false;
      });
    },
    onSelectSession (sessionId) {
      this.sessionSelected = sessionId;
      this.sessionResource = this.sessions.find(session => session.id === sessionId);
    },
    onAssignmentSent () {
      this.assignByEmailStarted = false;

      const product = this.products.find(product => product.id === this.productSelected);
      product.$request().$get('sessions', {sessionType: this.sessionTypes[this.sessionTypeSelected].value}).then(res => {
        this.sessions = res.$getEmbedded('sessions');
        this.onSelectSession(this.sessionSelected);
      });
    }
  }
};
</script>

<style lang="scss">
.member-progress-viewer {
  .vx-card {
    .vx-card__header {
      justify-content: left;

      .vx-card__title {
        min-width: 150px;
        align-self: flex-start;
      }
    }
  }

  .status-background {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-content: center;
    justify-content: center;

    &.icon-locked {
      background-color: #c4c4c4;
      border: 2px solid white;
    }

    &.icon-hidden{
      background-color: white;
      border: 2px solid white;
    }

    .status-icon {
      display: flex;
      width: 20px;
      height: 20px;
      align-self: center;
      justify-self: center;

      &.icon-hidden,
      &.icon-locked {
        width: 12px;
        height: 12px;

        .vs-icon {
          font-size: 12px;
        }
      }

      .vs-icon {
        font-size: 20px;
      }
    }
  }

  .content-viewer {
    height: 100%;
    border-radius: 5px;
    overflow: hidden;
  }

  .vs-list {
    padding: 0;

    .vs-list--item {
      margin-bottom: 3px;
      padding: 2px 10px;
      border-radius: 5px;
      border: 1px solid #EDEDED;
      cursor: pointer;

      &:last-child {
        margin-bottom: 0;
      }

      &.selected {
        background-color: #EDEDED;
      }

      .vs-list--title {
        font-weight: normal;
      }
    }
  }
}
</style>
